import React from "react";
import { Col, Row } from "react-bootstrap";
import { motion } from "framer-motion";

const techStack = [
  { name: "React", category: "Frontend", icon: "fa-code" },
  { name: "Next.js", category: "Frontend", icon: "fa-server" },
  { name: "Python", category: "Backend", icon: "fa-terminal" },
  { name: "Node.js", category: "Backend", icon: "fa-cog" },
  { name: "Firebase", category: "Cloud", icon: "fa-cloud" },
  { name: "PostgreSQL", category: "Database", icon: "fa-database" },
  { name: "TensorFlow", category: "AI / ML", icon: "fa-microchip" },
  { name: "Docker", category: "DevOps", icon: "fa-cube" },
];

function TechnologyComponent() {
  return (
    <div className="tech-section-new">
      <div className="container">
        <Row className="align-items-center">
          <Col xs={12} md={5}>
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <div className="section-badge tech-badge-new">Technology</div>
              <h3 className="tech-title-new">
                Modern Stack. <br />
                <span style={{ color: "#63FFCD" }}>Intelligent Solutions.</span>
              </h3>
              <p className="tech-desc-new">
                We don't just write code — we build intelligence. Our stack
                integrates the latest in AI and cloud computing to create
                applications that think, adapt, and scale with your business.
              </p>
            </motion.div>
          </Col>
          <Col xs={12} md={7}>
            <div className="tech-grid-new">
              {techStack.map((tech, i) => (
                <motion.div
                  key={tech.name}
                  className="tech-card-new"
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.4, delay: i * 0.08 }}
                  whileHover={{ y: -4, transition: { duration: 0.2 } }}
                >
                  <span className={`fa ${tech.icon} tech-card-icon`}></span>
                  <span className="tech-card-name">{tech.name}</span>
                  <span className="tech-card-cat">{tech.category}</span>
                </motion.div>
              ))}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default TechnologyComponent;
